// The delay between the context clock and the sound reaching the listener, and how it was found.
//
// Where the browser reports `outputLatency` it is used as it is, and the device's calibration is taken off the taps (the
// calibration then holds the human lag and whatever the report misses). Where it does not (some Safari builds), the delay is
// `baseLatency` plus the device's calibration, if it has one, so the count display and the taps agree; the taps are then
// not corrected a second time. Diagnostics says which was used.

export type LatencySource = 'reported' | 'base+calibration' | 'base';

export interface Latency {
  /** Seconds used for the count display, Test me, the loop start and the taps' time. */
  readonly used: number;
  /** What a calibration run measures its taps against: the figure without any calibration in it. */
  readonly baseline: number;
  readonly source: LatencySource;
}

const ok = (x: unknown): x is number => typeof x === 'number' && Number.isFinite(x) && x >= 0;

export function chooseLatency(reported: unknown, base: unknown, calibrationS: number | null): Latency {
  if (ok(reported)) return { used: reported, baseline: reported, source: 'reported' };
  const b = ok(base) ? base : 0;
  if (calibrationS !== null && Number.isFinite(calibrationS)) return { used: Math.max(0, b + calibrationS), baseline: b, source: 'base+calibration' };
  return { used: b, baseline: b, source: 'base' };
}

/** Words for Diagnostics. */
export function latencyWords(l: Latency): string {
  const ms = `${(l.used * 1000).toFixed(1)} ms`;
  if (l.source === 'reported') return `${ms} (reported by the browser)`;
  if (l.source === 'base+calibration') return `${ms} (the browser reports none: base latency plus your calibration)`;
  return `${ms} (the browser reports none: base latency; calibrate to improve it)`;
}
